export const Field = ({ label, testid, multiline = false, className = "", hint, ...props }) => (
  <div className={className}>
    <label className="xy-label" htmlFor={testid}>
      {label}
    </label>
    {multiline ? (
      <textarea id={testid} data-testid={testid} rows={3} className="xy-input resize-none" {...props} />
    ) : (
      <input id={testid} data-testid={testid} className="xy-input" {...props} />
    )}
    {hint ? <p className="mt-1.5 text-xs text-slate-500">{hint}</p> : null}
  </div>
);
